import React, { ReactElement, useEffect, useMemo, useState } from 'react';
import { useKeycloak } from 'utils/keycloakProvider';
import { useUser } from 'store/userContext';
import { useDeadlines } from 'store/deadlineContext';
import { UserEmployeeInfoRepository } from 'api/repository';
import { NotificationDeadline } from 'api/types/UserEmployeeInfo';
import { Button } from 'react-bootstrap';
import CompanySelectModal from './CompanySelectModal';
import './user.scss';

const UserComp = (): ReactElement => {
  const { keycloak } = useKeycloak();

  const { userId, setUserId, hydrated } = useUser();
  const { deadlines, setDeadlines } = useDeadlines();

  const [companySelectModal, setCompanySelectModal] = useState(false);

  const [userMenuOpen, setUserMenuOpen] = useState(false);

  // --- UJEDNOLICONE: zapisujemy JSON, czytamy JSON ---
  const getStorageUserData = () => {
    const data = window.sessionStorage.getItem('employeeKioskUser');
    if (data === null || data === '') return null;

    try {
      const parsed = JSON.parse(data); // zapisujemy JSON.stringify(id)
      const num = Number(parsed);
      return Number.isFinite(num) ? num : null;
    } catch {
      return null;
    }
  };

  const userData = getStorageUserData();

  const [getUserEmployeeInfo, updateUserEmployeeInfo] =
    UserEmployeeInfoRepository.useGetUserEmployeeInfo();

  const users = useMemo(() => getUserEmployeeInfo ?? [], [getUserEmployeeInfo]);

  const [name, setName] = useState<undefined | string>(undefined);
  const [company, setCompany] = useState<undefined | string>(undefined);

  // aktualnie wybrany rekord (na podstawie userId z contextu)
  const selected = useMemo(() => {
    if (!users.length) return null;
    if (userId === null) return null;
    return users.find((u) => u.id === userId) ?? null;
  }, [users, userId]);

  // --- NOWE: handler zmiany "firmy" (czyli wyboru rekordu) ---
  const handleChange = (nextId: number) => {
    const u = users.find((x) => x.id === nextId);
    if (!u) return;

    setUserId(u.id);
    setName(`${u.firstName} ${u.lastName}`);
    setCompany(u.companyName);

    window.sessionStorage.setItem('employeeKioskUser', JSON.stringify(u.id));
  };

  useEffect(() => {
    if (!hydrated) return;
    if (!users || users.length === 0) return;

    // 1) jeśli jest tylko jedna pozycja, ustaw ją
    if (users.length === 1) {
      const u = users[0];
      setName(`${u?.firstName} ${u?.lastName}`);
      setCompany(u?.companyName);
      setUserId(u?.id);
      window.sessionStorage.setItem('employeeKioskUser', JSON.stringify(u?.id));
      return;
    }

    // 2) jeśli mamy zapis w sessionStorage, spróbuj go użyć
    if (userData !== null) {
      const u = users.find((e) => e.id === Number(userData));
      if (u) {
        setName(`${u?.firstName} ${u?.lastName}`);
        setCompany(u?.companyName);
        setUserId(u?.id);
        return;
      }
    }

    // 3) fallback: pierwsza pozycja
    const u = users[0];
    setName(`${u?.firstName} ${u?.lastName}`);
    setCompany(u?.companyName);
    setUserId(u?.id);
    window.sessionStorage.setItem('employeeKioskUser', JSON.stringify(u?.id));
  }, [hydrated, users, userData, setUserId]);

  const dataDeadlines = UserEmployeeInfoRepository.useGetNotificationDeadline(
    async (data: NotificationDeadline[] | null | undefined) => {
      if (data && data !== null) {
        setDeadlines(data);
      }
    },
    async () => {}
  );

  useEffect(() => {
    if (userId && userId !== null) {
      dataDeadlines({ userId });
    }
  }, [userId]);

  return (
    <div className="topMenuUser">
      <div className="topMenuUserBlock">
        {/*   <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12 0C13.5913 0 15.1174 0.632141 16.2426 1.75736C17.3679 2.88258 18 4.4087 18 6C18 7.5913 17.3679 9.11742 16.2426 10.2426C15.1174 11.3679 13.5913 12 12 12C10.4087 12 8.88258 11.3679 7.75736 10.2426C6.63214 9.11742 6 7.5913 6 6C6 4.4087 6.63214 2.88258 7.75736 1.75736C8.88258 0.632141 10.4087 0 12 0ZM12 15C18.63 15 24 17.685 24 21V24H0V21C0 17.685 5.37 15 12 15Z"
            fillRule="evenodd"
            clipRule="evenodd"
          />
        </svg> */}

        {/*  <svg
          width="50"
          height="50"
          viewBox="0 0 50 50"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g
            fill="none"
            stroke="currentColor"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M12 12 C20 3, 30 3, 38 12" />

            <path d="M38 41 C30 49, 20 49, 12 41" />
          </g>

          <g fill="currentColor">
            <path d="M38 12 L33.698 10.469 L36.99 7.547 Z" />

            <path d="M12 41 L16.384 42.272 L13.272 45.384 Z" />
          </g>

          <g fill="currentColor" transform="translate(13 13) scale(1)">
            <path
              d="M12 0C13.5913 0 15.1174 0.632141 16.2426 1.75736C17.3679 2.88258 18 4.4087 18 6C18 7.5913 17.3679 9.11742 16.2426 10.2426C15.1174 11.3679 13.5913 12 12 12C10.4087 12 8.88258 11.3679 7.75736 10.2426C6.63214 9.11742 6 7.5913 6 6C6 4.4087 6.63214 2.88258 7.75736 1.75736C8.88258 0.632141 10.4087 0 12 0ZM12 15C18.63 15 24 17.685 24 21V24H0V21C0 17.685 5.37 15 12 15Z"
              fillRule="evenodd"
              clipRule="evenodd"
            />
          </g>
        </svg> */}
        <div
          className="userIconBtn"
          role="button"
          tabIndex={0}
          onClick={() => setUserMenuOpen((v) => !v)}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') setUserMenuOpen((v) => !v);
          }}
          aria-label="test"
        >
          <svg
            width="50"
            height="50"
            viewBox="-4 -4 58 58"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g transform="translate(13, 13)">
              <path
                d="M12 0C13.5913 0 15.1174 0.632141 16.2426 1.75736C17.3679 2.88258 18 4.4087 18 6C18 7.5913 17.3679 9.11742 16.2426 10.2426C15.1174 11.3679 13.5913 12 12 12C10.4087 12 8.88258 11.3679 7.75736 10.2426C6.63214 9.11742 6 7.5913 6 6C6 4.4087 6.63214 2.88258 7.75736 1.75736C8.88258 0.632141 10.4087 0 12 0ZM12 15C18.63 15 24 17.685 24 21V24H0V21C0 17.685 5.37 15 12 15Z"
                fill="currentColor"
                fillRule="evenodd"
                clipRule="evenodd"
              />
            </g>

            <path
              d="M48 25 A 23 23 0 0 0 7.5 10"
              stroke="currentColor"
              strokeWidth="3"
              strokeLinecap="round"
            />
            <path
              d="M48 25L44 20M48 25L51 20"
              stroke="currentColor"
              strokeWidth="3"
              strokeLinecap="round"
              strokeLinejoin="round"
            />

            <path
              d="M2 25 A 23 23 0 0 0 42.5 40"
              stroke="currentColor"
              strokeWidth="3"
              strokeLinecap="round"
            />
            <path
              d="M2 25L6 30M2 25L-1 30"
              stroke="currentColor"
              strokeWidth="3"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>

        <div className="textInfoBox">
          <span>{name || ''}</span>

          {/* <span>{company || ''}</span> */}

          <span className="ellipsis" title={`${company || ''}`}>
            {company || ''}
          </span>

          <Button
            type="button"
            onClick={() => setCompanySelectModal(true)}
            className="green"
          >
            Zmień
          </Button>
        </div>
      </div>
      {companySelectModal && (
        <CompanySelectModal
          users={users}
          selectedId={selected?.id ?? null}
          onSelect={(id) => {
            handleChange(id);
            setCompanySelectModal(false);
          }}
          onClose={() => setCompanySelectModal(false)}
        />
      )}
    </div>
  );
};

export default UserComp;
